////////LIBRARY/////////
import { find, get, isEmpty, isUndefined, map, filter, isNull } from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { shallowEqual, useSelector } from 'react-redux'
///////COMPONENTS///////
import { BodyCells, BodyCellsSticky, TableBodyWrapper, SkeletonActionWrapper } from '../../../../theme/GlobalCss'
import 'react-loading-skeleton/dist/skeleton.css'
import TableCampaignRows from '../TableCampaignRows'
import TableNestedRows from '../TableNestedRows'
import TableRows from '../TableRows'
// Unused imports, came from previous windowing method
// import styled from 'styled-components'
// import LoadingInLine from '../../../LoadingInLine'

const CellsSticky = ({ row, column, indexRow, dataSize, _kioskErrorsPrice, ...rest }) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<BodyCellsSticky nowrap>
			{row.rowTableSkeleton ? (
				<Skeleton circle count={3} wrapper={SkeletonActionWrapper} />
			) : (
				<column.component row={row} column={column} indexRow={indexRow} dataSize={dataSize} {...rest} />
			)}
		</BodyCellsSticky>
	)
}

const Cells = (props) => {
	let checkRowNull = get(props.row, props.column.dataHook, '-')
	if (isNull(checkRowNull) || isUndefined(checkRowNull) || checkRowNull == '') checkRowNull = '-'
	const k = find(props.storedValues, (o, k) => parseInt(k) === props.row.itemkioskId)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<BodyCells nowrap>
			{props.column.useCustomSkeleton ? (
				props.renderProps ? (
					<props.renderProps
						row={props.row}
						column={props.column}
						register={props.register}
						setValue={props.setValue}
						error={props.error}
						indexRow={props.indexRow}
						dataSize={props.dataSize}
						storedValues={k}
						setStoredValues={props.setStoredValues}
					/>
				) : (
					checkRowNull.toString()
				)
			) : props.row.rowTableSkeleton ? (
				<Skeleton />
			) : props.renderProps ? (
				<props.renderProps
					row={props.row}
					column={props.column}
					register={props.register}
					setValue={props.setValue}
					error={props.error}
					indexRow={props.indexRow}
					dataSize={props.dataSize}
					storedValues={k}
					setStoredValues={props.setStoredValues}
				/>
			) : (
				checkRowNull.toString()
			)}
		</BodyCells>
	)
}

const TableBody = ({
	allData,
	editingData,
	columns,
	checkboxConf,
	register,
	editing,
	getValues,
	nestedValues,
	formError,
	inLineEdit,
	setInlineEdit,
	formState,
	setSelectedData,
	clearErrors,
	isCampaignBody,
	campaignValues,
	campaignUpdate,
	bodyWrapperRef,
	setWidthTable,
	setHeightTable,
	heightTable,
	tableDataSetter,
	setForceUnsort,
	isScrolling,
	storedValues,
	handleCheckValues,
	storedChecks,
	setStoredValues,
	setValue,
}) => {
	const data = editing ? editingData : allData

	const { user } = useSelector(
		(state) => ({
			user: state.user,
			globalLoading: state.globalLoading,
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const [hasRendered, setHasRendered] = useState(0)
	const [renderTable, setRenderTable] = useState()

	// Know how many rows we can show
	//const rowPerPage = data?.length
	//const [defaultVisibleRows, setDefaultVisibleRows] = useState(0)

	const [visibleColumns, setVisibleColumns] = useState(0)

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		setRenderTable(
			map(data, (row, rowid) => {
				if (!row.rowTableVisible && !row.rowTableSkeleton) return null
				if (!isUndefined(nestedValues)) {
					return (
						<TableNestedRows
							key={rowid}
							row={row}
							indexRow={rowid}
							dataSize={data.length}
							id={rowid}
							columns={columns}
							nestedValues={nestedValues}
							checkboxConf={checkboxConf}
							editing={editing}
							register={register}
							dataRef={data}
							tableDataSetter={tableDataSetter}
							setForceUnsort={setForceUnsort}
							handleCheckValues={handleCheckValues}
							storedChecks={storedChecks}
						/>
					)
				} else if (isCampaignBody) {
					return (
						<TableCampaignRows
							key={rowid}
							row={row}
							indexRow={rowid}
							dataSize={data.length}
							id={rowid}
							columns={columns}
							register={register}
							campaignValues={campaignValues}
							campaignUpdate={campaignUpdate}
							getValues={getValues}
							storedValues={storedValues}
						/>
					)
				} else {
					return (
						<TableRows key={rowid} error={formError[row.itemkioskId]}>
							{row.standardLine || isUndefined(row.standardLine) ? (
								checkboxConf &&
								!editing && // if check box is config and mass edit is not active
								(row.rowTableSkeleton ? (
									<BodyCells>
										<Skeleton circle wrapper={SkeletonActionWrapper} />
									</BodyCells>
								) : (
									<BodyCells nowrap>
										<input
											type="checkbox"
											name={rowid}
											ref={row.standardLine && register}
											value={JSON.stringify(row)} // put object typed to string in value of checkbox form ( getValues() )
											onClick={(e) => handleCheckValues(e.target.value)}
											checked={find(storedChecks, (o) => JSON.stringify(row) === o) ? true : false}
										/>
									</BodyCells>
								))
							) : checkboxConf ? (
								<div></div>
							) : null}
							{map(columns, (column, id) => {
								let actionAuthorized = true

								const f = find(user.identity.rolePrivileges.privileges, (o) => o.label === column.checkRight) ? true : false
								if (!isUndefined(column.checkRight) && !f && column.action) {
									actionAuthorized = false
								}
								if (!isUndefined(column.boolRight) && !column.boolRight) {
									actionAuthorized = false
								}
								return (
									(column.visibility || editing || inLineEdit.editId) && // if inline edit is active or mass edit active show all column
									actionAuthorized &&
									(column.action ? (
										<CellsSticky // column actions
											key={id}
											row={row}
											column={column}
											inlineEdit={inLineEdit} // content input data selected
											setInlineEdit={setInlineEdit} // inline data formator
											formState={formState} // react hook form validator list ( dity, isValid, touched ...)
											getValues={getValues}
											storedValues={storedValues}
											setStoredValues={setStoredValues}
											setValue={setValue}
											setSelectedData={setSelectedData} // table state [] with all row edited
											editing={editing} // table state bool
											clearErrors={clearErrors}
											indexRow={rowid}
											dataSize={data.length}
											{...column.rest}
										/>
									) : (
										<Cells // columns ordinary
											key={id}
											row={row}
											column={column}
											renderProps={
												// render edit input if inline edit or mass edit is active otherwise get component
												checkboxConf && (editing || inLineEdit.editId === row[inLineEdit.editKey])
													? column.edit || column.component
													: column.component
											}
											register={column.edit && register}
											nowrap
											error={formError} // error from form validator
											storedValues={storedValues}
											setStoredValues={setStoredValues}
											setValue={setValue}
										/>
									))
								)
							})}
						</TableRows>
					)
				}
			})
		)
		setHasRendered(hasRendered + 1)
	}, [data, formState, columns, isScrolling])

	useEffect(() => {
		// Everytime this var is incremented,
		// Get the size of rows
		if (hasRendered > 0) {
			if (heightTable !== bodyWrapperRef.current?.offsetHeight + 30) {
				setWidthTable(bodyWrapperRef.current?.offsetWidth)
				setHeightTable(bodyWrapperRef.current?.offsetHeight + 30)
			}

			// Know how many columns are visible
		}
		//setDefaultVisibleRows(Math.floor(tableOverflowHeight / defaultLineHeight))
	}, [hasRendered])

	useEffect(() => {
		const visColumns = filter(columns, { visibility: true })

		if (visColumns.length !== visibleColumns) {
			setWidthTable(bodyWrapperRef.current?.offsetWidth)
			setHeightTable(bodyWrapperRef.current?.offsetHeight + 30)
			setVisibleColumns(visColumns.length)
		}
	}, [columns])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TableBodyWrapper ref={bodyWrapperRef}>
			{
				renderTable
				/*isScrolling && isUndefined(noWindowing) ?
				<VirtualizeLoader height={tableOverflowHeight} virutalizeWidth={scrollBarWidth}>
					<td colspan={columns.length}><LoadingInLine isLoading={true} translations={translations}/></td>
				</VirtualizeLoader>
			:
				renderTable
			*/
			}
		</TableBodyWrapper>
	)
}

TableBody.propTypes = {
	columns: PropTypes.array.isRequired,
	data: PropTypes.array,
}
TableBody.defaultPropTypes = {
	columns: [],
	data: [],
}

export default TableBody
